<template>
  <div id="content">
    <app-navbar></app-navbar>
    <div class="container">
      <router-view></router-view>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
import AppNavbar from 'components/navbar/app-navbar'
import AppFooter from 'components/footer/app-footer'

export default {
  name: 'DefaultLayout',
  components: { AppNavbar, AppFooter }
}
</script>

<style scoped>
.container {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  margin-top: 25px;
  margin-bottom: 25px;
}

#content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

/* IE10+ CSS styles */
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  #content {
    display: inline-block;
    min-height: 100vh;
  }

  .container {
    min-height: 67vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/default/index.vue